import { render, staticRenderFns } from "./AddOrUpdateFileDialog.vue?vue&type=template&id=57fa0770&scoped=true"
import script from "./AddOrUpdateFileDialog.vue?vue&type=script&lang=js"
export * from "./AddOrUpdateFileDialog.vue?vue&type=script&lang=js"
import style0 from "./AddOrUpdateFileDialog.vue?vue&type=style&index=0&id=57fa0770&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57fa0770",
  null
  
)

export default component.exports